import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Flame, Heart, Lock, MapPin, Sparkles } from "lucide-react";

/** « Qui m'a aimé » : la preuve qu'on plaît. Les abonnés Love voient les visages,
 *  les autres voient des silhouettes verrouillées — et la raison de s'abonner. */
export const LoveAdmirateurs = ({ donnees, moiId, onDiscuter, CarteProfil }) => {
  if (!donnees) return null;
  const { total, abonne, admirateurs } = donnees;

  if (!total) {
    return (
      <p className="py-24 text-center text-stone-500" data-testid="love-admirateurs-vide">
        Personne ne vous a encore aimé. Réagissez aux profils : les coups de cœur attirent
        les coups de cœur.
      </p>
    );
  }

  if (abonne) {
    return (
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        data-testid="love-admirateurs-grille">
        {admirateurs.map((p, i) => (
          <CarteProfil key={p.id} profil={p} index={i} moiId={moiId}
            onDiscuter={onDiscuter} onReagir={null} onPartagerNumero={null} />
        ))}
      </div>
    );
  }

  return (
    <div className="mt-8" data-testid="love-admirateurs-verrouilles">
      <div className="flex flex-col items-start gap-4 rounded-3xl bg-[#2F363F] p-7 text-white sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-heading text-2xl font-extrabold sm:text-3xl">
            {total} {total > 1 ? "personnes vous ont aimé" : "personne vous a aimé"}
          </p>
          <p className="mt-1.5 text-sm text-white/70">
            Abonnez-vous à FodindinLove pour voir qui, et lui répondre tout de suite.
          </p>
        </div>
        <Link to="/abonnement?categorie=love" data-testid="love-admirateurs-abonnement"
          className="shrink-0 rounded-full bg-[#FF4757] px-6 py-3.5 text-sm font-bold transition-transform hover:scale-[1.03]">
          Voir qui m'a aimé
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {admirateurs.slice(0, 12).map((a, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04 }} data-testid={`love-admirateur-verrouille-${i}`}
            className="relative overflow-hidden rounded-3xl bg-white p-6 text-center ring-1 ring-stone-900/5">
            <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-stone-200 font-heading text-3xl font-extrabold text-stone-400 blur-[2px]">
              {a.initiale}
            </span>
            <p className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold text-stone-700">
              {a.reaction === "feu" ? <Flame size={13} className="text-[#EA580C]" />
                : <Heart size={13} className="text-[#FF4757]" />}
              {a.age ? `${a.age} ans` : "Profil Love"}
            </p>
            {a.ville && (
              <p className="mt-1 inline-flex items-center gap-1 text-[11px] text-stone-500">
                <MapPin size={10} /> {a.ville}
              </p>
            )}
            <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-stone-100 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-stone-500">
              <Lock size={10} /> Masqué
            </span>
          </motion.div>
        ))}
      </div>

      <p className="mt-6 inline-flex items-center gap-1.5 text-xs text-stone-500">
        <Sparkles size={12} className="text-[#FF4757]" />
        Les profils restent masqués jusqu'à votre abonnement : personne ne sait que vous regardez.
      </p>
    </div>
  );
};
